import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

type UiSize = 'sm' | 'md';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  /** Visual density. `sm` is the compact toolbar variant (32 px tall).
   *  Named `uiSize` because `size` is a native input attribute. */
  uiSize?: UiSize;
}

const sizeClass: Record<UiSize, string> = {
  sm: 'h-8 px-2.5 text-sm',
  md: 'px-3 py-2 text-sm',
};

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, uiSize = 'md', ...rest }, ref) => (
    <input
      ref={ref}
      className={cn(
        'block w-full rounded-md border border-slate-300 bg-white shadow-sm transition-colors',
        sizeClass[uiSize],
        'focus:border-forest-500 focus:outline-none focus:ring-1 focus:ring-forest-500',
        'disabled:bg-slate-50 disabled:text-slate-500',
        'dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100 dark:placeholder:text-slate-500',
        'dark:focus:border-forest-400 dark:focus:ring-forest-400',
        'dark:disabled:bg-slate-900 dark:disabled:text-slate-500',
        className,
      )}
      {...rest}
    />
  ),
);
Input.displayName = 'Input';
